module.exports = __webpack_public_path__ + "img/120h100_s_okoshkom_fortochkoy_50h50_v_nizhney_chasti.d0f6e613.svg";